import React from "react";

import { useHistory } from "react-router";
import { IonIcon } from "@ionic/react";
import { searchOutline } from "ionicons/icons";

import cx from "classnames";

interface SearchButtonProps {
  buttonStyles?: string;
  iconStyles?: string;
}

const SearchButton = ({ buttonStyles, iconStyles }: SearchButtonProps) => {
  const history = useHistory();

  const handleSearch = () => {
    history.push("/search-main-categories");
  };

  return (
    <button
      onClick={handleSearch}
      className={cx("flex bg-[#f4f4f4] border-0 rounded-full px-5 text-4.5 py-1 focus-visible:outline-none", buttonStyles)}
    >
      <IonIcon className={cx("ion-no-margin", iconStyles)} icon={searchOutline} color="gray" />
    </button>
  );
};

export default SearchButton;
